import { render, staticRenderFns } from "./EntityField.vue?vue&type=template&id=3f968e16"
import script from "./EntityField.vue?vue&type=script&lang=js"
export * from "./EntityField.vue?vue&type=script&lang=js"
import style0 from "./EntityField.vue?vue&type=style&index=0&id=3f968e16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports